import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { Header } from 'components/organisms';
import { Menu } from 'components/organisms/Menu';
import { ReactComponent as LogoWhiteSvg } from 'assets/images/logo.svg';
import s from '../../styles/common/footer.module.scss';

type Props = {
  children: React.ReactNode;
  hasFixedBanner?: boolean;
};

export const SurveyLayout: React.FC<Props> = ({ children, hasFixedBanner = false }) => {
  return (
    <>
      <Helmet
        title={'P-man 三菱地所が事業化検討中 ペットのコンシェルジュがいる賃貸マンション'}
        meta={[
          {
            name: 'description',
            content: '真の「ペットと人の共生」マンションを目指し、三菱地所が事業化検討中のプロジェクトです',
          },
          { property: 'og:title', content: 'P-man 三菱地所が事業化検討中 ペットのコンシェルジュがいる賃貸マンション' },
          { property: 'og:type', content: 'website' },
          { property: 'og:url', content: 'https://p-man.mec.co.jp/' },
          { property: 'og:image', content: 'https://p-man.mec.co.jp/ogp.png' },
          {
            property: 'og:description',
            content: '真の「ペットと人の共生」マンションを目指し、三菱地所が事業化検討中のプロジェクトです',
          },
          { name: 'twitter:card', content: 'summary_large_image' },
          { name: 'twitter:image', content: 'https://p-man.mec.co.jp/ogp.png' },
          {
            name: 'twitter:site',
            content: '真の「ペットと人の共生」マンションを目指し、三菱地所が事業化検討中のプロジェクトです',
          },
        ]}
      >
        <script async src="https://www.googletagmanager.com/gtag/js?id=G-BTQ7CE5MB4"></script>
        <script>
          {`
              window.dataLayer = window.dataLayer || [];
              function gtag(){dataLayer.push(arguments);}
              gtag('js', new Date());
              gtag('config', 'G-BTQ7CE5MB4', { send_page_view: false });
            `}
        </script>
      </Helmet>

      <Header />
      <Menu />
      {children}
      <SurveyFooter hasFixedBanner={hasFixedBanner} />
    </>
  );
};

// Survey用の簡略化されたフッター
interface SurveyFooterProps {
  hasFixedBanner?: boolean;
}

const SurveyFooter: React.FC<SurveyFooterProps> = ({ hasFixedBanner = false }) => {
  const footerStyle: React.CSSProperties = hasFixedBanner ? {
    paddingBottom: '10rem'
  } : {};

  return (
    <footer className={s.footer} style={footerStyle}>
      <div className={s.logoBlock}>
        <Link to={'/#top'}>
          <LogoWhiteSvg className={s.logo} />
        </Link>
        <p>三菱地所が事業化検討中　ペットのコンシェルジュがいる賃貸マンションプロジェクト　P-man</p>
        <h5>本件は事業化検討段階のため内容が変更となる場合があります</h5>
      </div>
      <div className={s.contents}>
        <nav>
          <ul>
            <li>
              <a href="https://www.mec.co.jp/privacy/" target="_blank" rel="noreferrer">
                Privacy Policy
              </a>
            </li>
            <li>
              <Link to={'/terms'}>利用規約</Link>
            </li>
          </ul>
        </nav>
        <p className={s.copyright}>COPYRIGHT © MITSUBISHI ESTATE CO., LTD. ALL RIGHTS RESERVED.</p>
      </div>
    </footer>
  );
};

export default SurveyLayout;